"use client";

import IMG from "../../constants/image";
import {Link, useLocation} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {PATH} from "../../constants";
import {ENV} from "../../network/config";
import {Logo} from "../Logo/Logo";
import ImageBasic from "../Common/Image/ImageBasic";
import IconText from "../Common/Text/IconText";
import DialogNotification from "../Notification/DialogNotification";
import notificationStore from "../../store/notificationStore";
import {fetchCountNoti, fetchNotification} from "../../services/notiServices";
import merchantStore from "../../store/merchantStore";
import {ERROR_CODE} from "../../constants/error";

const Heading = () => {
    const location = useLocation();
    const pathname = location.pathname;
    const [isActived, setIsActived] = useState(false);
    const {countNoti} = notificationStore();
    const {merchantProfile} = merchantStore() || {};

    const handleMouseEnter = () => {
        setIsActived(true); // Show dialog when hover
    };

    const handleMouseLeave = () => {
        setIsActived(false); // Hide dialog when hover ends
    };

    useEffect(() => {
        fetchNotification({
            page: 1,
            size: 5,
            type: 'seller_order'
        })
        fetchCountNoti({
            type: 'seller_order'
        })

    }, []);

    return (
        <div className="hidden md:flex w-full min-w-0 justify-between h-[90px] items-center px-4 sm:px-6 md:px-10 lg:px-16 xl:px-32">
            <Link className="cursor-pointer" to={ENV.FUNONG_DOMAIN}>
                <Logo url={IMG.logoDark} title={"Kênh người bán"}/>
            </Link>
            {pathname === PATH.LOGIN ? (
                <IconText
                    className="font-bold text-xl"
                    iconClass="rotate-180"
                    text={"Đăng ký làm nhà bán hàng"}
                />
            ) : (
                <div className="flex items-center justify-center text-center space-x-4 text-black text-sm">
                    <Link
                        className="text-center flex flex-col items-center"
                        to={merchantProfile?.code !== ERROR_CODE["MERCHT-05"] ? PATH.HOME : '#'}
                    >
                        <div className="flex justify-center">
                            <ImageBasic className="w-6" src={IMG.icon.home}/>
                        </div>
                        <div className="text-center">Trang chủ</div>
                    </Link>
                    <div
                        className="relative text-center flex flex-col items-center cursor-pointer"
                        onMouseEnter={handleMouseEnter} // Trigger on hover
                        onMouseLeave={handleMouseLeave} // Hide on hover leave
                    >
                        <div className="flex justify-center">
                            <ImageBasic className="w-6" src={IMG.icon.notification}/>
                        </div>
                        <div>Thông báo</div>
                        {countNoti?.total > 0 && (
                            <div
                                className="absolute -top-1 right-1 bg-red text-white text-[10px] font-bold rounded-full w-6 h-4 flex items-center justify-center">
                                {countNoti?.total > 99 ? "99+" : countNoti?.total}
                            </div>
                        )}
                        <DialogNotification merchantProfile={merchantProfile} isActived={isActived}/>
                    </div>
                </div>
            )}
        </div>
    );
};
export default Heading;
